import { Box } from "@mui/material";
import React from "react";

const WindowsServerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 255.995 255.995"
    >
      <g
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
      >
        <g
          fill="#ddd"
          fillOpacity="0"
          style={{ mixBlendMode: "normal" }}
          transform="matrix(1.2 0 0 1.2 -25.6 -25.6)"
        >
          <path d="M21.333 234.662V21.333h213.33v213.33z"></path>
        </g>
        <path
          fill="#001589"
          d="M12 16H3v7.75l9 1.238zm0-11L3 6.25V14h9zm2-.25V14h13V3zM14 16v9.25L27 27V16z"
          transform="matrix(1.2 0 0 1.2 -25.6 -25.6) scale(8.53333)"
        ></path>
      </g>
    </svg>
  );
};

export default WindowsServerIcon;
